import { render, staticRenderFns } from "./PhoneVerificationSkeleton.vue?vue&type=template&id=b0bffb2e"
import script from "./PhoneVerificationSkeleton.vue?vue&type=script&lang=js"
export * from "./PhoneVerificationSkeleton.vue?vue&type=script&lang=js"
import style0 from "./PhoneVerificationSkeleton.vue?vue&type=style&index=0&id=b0bffb2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports